import { render, staticRenderFns } from "./cardException.vue?vue&type=template&id=20d65386&scoped=true&"
import script from "./cardException.vue?vue&type=script&lang=js&"
export * from "./cardException.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d65386",
  null
  
)

export default component.exports